import {
    AckoMainTheme,
    ThemeProvider,
} from '@acko-tech/building-blocks.ui.theme';
import Dashboard from 'components/dashboard';

function POS() {
    return (
        <ThemeProvider theme={AckoMainTheme}>
            <Dashboard />
        </ThemeProvider>
    );
}

export default POS;
